<template>
    <div>
      登录中...
    </div>
</template>

<script>
import qs from 'qs'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  data () {
    return {
      // account: this.$route.query.account
    }
  },
  created () {
    // let account = this.account
    // if (!account) {
    //   alert('登录失败')
    //   return
    // }
    // token = JSON.parse(token)
    // const params = qs.stringify({ account: account })
    this.$http.post('/api/v1/portal/oa/login').then(resp => {
      if (resp.code === 200) {
        this.$ls.set(ACCESS_TOKEN, resp.result.token, 7 * 24 * 60 * 60 * 1000)
        this.$router.push('/dashboard/workplace')
      } else {
        alert('登录失败')
      }
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
</style>
